const zhCN = {
  app: {
    title: '宝贝习惯园',
  },
  install: {
    title: '添加到主屏幕，下次直接打开',
    action: '立即安装',
    iosHint: '点击底部 分享按钮，然后选择「添加到主屏幕」',
  },
  common: {
    systemSettings: '系统设置',
    logout: '退出登录',
    logoutShort: '退出',
    current: '当前',
    close: '关闭',
    delete: '删除',
    save: '保存',
    saveSettings: '保存设置',
    cancel: '取消',
    studentsCount: '{{count}} 个孩子',
    loading: '加载中...',
    confirm: '确定',
    prestigeReason: '完成了养成！🎉',
    add: '添加',
    all: '全部',
    unassigned: '未分组',
    networkError: '当前网络不可用，请检查网络连接后重试',
    networkRestored: '网络已恢复，可以继续操作',
  },
  petLife: {
    states: {
      normal: '状态良好',
      hungry: '有点饿了',
      weak: '有些虚弱',
      dying: '快撑不住了',
      dead: '已沉睡',
    },
    hints: {
      normal: '继续加分就能保持活力。',
      hungry: '给它加分一次，就能恢复精神。',
      weak: '宠物有些虚弱，记得尽快加分喂养。',
      dying: '宠物状态危险，需要尽快加分鼓励。',
      dead: '宠物已经沉睡，给它加分就能唤醒。',
    },
  },
  settings: {
    tabs: {
      students: '孩子管理',
      items: '行为习惯',
      checkin: '打卡任务',
      growth: '成长配置',
      parentShare: '分享链接',
      account: '基础设置',
    },
    parentShare: {
      title: '分享链接',
      subtitle: '生成链接后发给家人，输入孩子姓名即可查看”记录 + 宠物图鉴”',
      enabled: '已开启',
      disabled: '已关闭',
      disabledHint: '关闭后打开链接会提示”已关闭查看功能”',
      processing: '处理中...',
      generateLink: '生成链接',
      copyLink: '复制链接',
      rotateLink: '重置链接',
      linkPlaceholder: '点击“生成链接”后会显示在这里',
      tip: '建议：如需失效旧链接可点击”重置链接”',
      footerHint: '生成链接发给家人，输入姓名即可查看',
      toast: {
        generated: '链接已生成',
        generateFailed: '生成链接失败',
        rotated: '链接已重置',
        rotateFailed: '重置链接失败',
        copied: '链接已复制',
        copyFailed: '复制失败',
      },
    },
    account: {
      changePassword: '修改密码',
      currentClassName: '当前家庭名称',
      classList: '家庭列表',
      addClass: '添加家庭',
      newClassPlaceholder: '例如：我的家庭',
      studentsCount: '{{count}} 个孩子',
      creating: '创建中...',
      create: '创建',
      deleteClass: '删除家庭',
      desktop: {
        title: '添加到桌面',
        desc: '将宝贝习惯园添加到电脑桌面，下次直接双击打开，无需输入网址。',
        download: '下载桌面快捷方式',
        hint: '下载后将文件拖到桌面即可',
        filename: '宝贝习惯园',
      },
    },
    license: {
      permanent: '永久授权',
      validUntil: '有效期至：{{date}}',
    },
    language: {
      label: '语言',
      zhCN: '简体中文',
      zhTW: '繁体中文',
      enUS: 'English',
    },
    footer: {
      hintAccount: '设置修改后点击保存生效',
      hintGrowth: '成长配置修改后点击保存生效',
      hintInstant: '此页面操作立即生效',
    },
    icons: {
      honor: '荣誉',
      study: '学习',
      activity: '文体',
      nature: '自然',
      food: '美食',
      life: '生活',
    },
    growth: {
      title: '成长阶段配置',
      subtitle: '设置每个阶段所需的累计积分数量',
      level: '{{level}}级',
      tip: '说明：数字代表”累计获得”的积分总数。例如5级设置为30，意味着孩子总共获得30个积分时将升至5级。',
      errorNotIncreasing: '第{{level}}级的积分必须大于前一级',
    },
    sound: {
      title: '开启音效',
      subtitle: '控制当前家庭的加分、升级等提示音是否启用。',
    },
    petLife: {
      title: '衰减配置',
      subtitle: '设置连续多少天未加分后进入不同状态。',
      enabled: '开启衰减',
      disabled: '已关闭',
      enabledDesc: '宠物会根据未加分天数进入饥饿、虚弱等状态',
      disabledDesc: '宠物永远保持状态良好',
      hungryAfterDays: '饥饿阈值',
      weakAfterDays: '虚弱阈值',
      dyingAfterDays: '濒危阈值',
      sleepAfterDays: '沉睡阈值',
      reset: '恢复默认值',
      tip: '阈值必须递增，系统会按自然日计算未加分天数。积分为负数时会立刻进入沉睡状态；积分恢复到 0 及以上后，才按阈值规则显示状态。再次加分会立即恢复到正常状态（若积分仍为负，则仍显示沉睡）。',
      rulePreview: '当前规则：{{hungryAfterDays}} 天进入饥饿，{{weakAfterDays}} 天进入虚弱，{{dyingAfterDays}} 天进入濒危，{{sleepAfterDays}} 天进入沉睡。',
      skipWeekends: '周末（周六、周日）不计入衰减天数',
      validation: {
        order: '请输入有效递增阈值：饥饿 < 虚弱 < 濒危 < 沉睡，且都必须大于等于 1。',
      },
      preview: {
        title: '宠物状态图例预览',
        hungry: '饥饿状态',
        weak: '虚弱状态',
        dying: '濒危状态',
        dead: '沉睡状态',
        zoomHint: '点击放大查看',
      },
    },
    items: {
      title: '行为习惯配置',
      subtitle: '设置行为习惯项目 ({{count}}个)。',
      hint: '(提示: 当前满级需累计 {{maxPoints}} 分，请合理设置分值)',
      importSystemTemplate: '导入系统模板',
      importSystemTemplateToast: '已导入系统模板：新增 {{created}} 项，跳过 {{skipped}} 项',
      importSystemTemplateFailed: '导入系统模板失败',
      importSystemTemplateModal: {
        title: '导入系统模板',
        desc: '将系统内置的打卡任务、加分项、减分项、小卖部商品追加到当前家庭，不会覆盖现有项。',
        confirm: '确认导入',
        ageRangeLabel: '选择年龄段',
        'ageRange_3-5': '3-5 岁',
        'ageRange_6-9': '6-9 岁',
        ageRange_10plus: '10+ 岁',
      },
      subTabs: {
        bonus: '加分项',
        deduction: '减分项',
      },
      newItemPlaceholder: {
        bonus: '项目名称 (如: 按时起床、做家务)',
        deduction: '项目名称 (如: 拖延、乱发脾气)',
      },
      points: '{{points}} 分',
    },
    students: {
      title: '孩子名单',
      subtitle: '当前家庭共 {{count}} 人',
      bulkAdd: '📄 批量添加',
      bulkCancel: '取消批量',
      bulkHint: '每行输入一个孩子姓名 (最多50字)，可直接从Excel粘贴:',
      bulkPlaceholder: '张三\n李四\n王五',
      addAll: '添加全部',
      singlePlaceholder: '输入孩子姓名...',
      bulkAddSuccess: '成功添加 {{count}} 个孩子',
      bulkAddFailed: '批量添加失败',
      alreadyExists: '该孩子已存在',
      skipped: '成功添加 {{added}} 人，跳过 {{skipped}} 名重复孩子',
      allSkipped: '所有孩子均已存在，无需添加',
      deleteConfirm: {
        title: '确认删除孩子?',
        descPrefix: '您确定要删除 ',
        descSuffix: ' 吗？',
        descLine2: '此操作无法撤销。',
        confirm: '确认删除',
      },
    },
    pets: {
      assign: {
        title: '一键分配宠物',
        subtitle: '随机为所有孩子分配新的宠物',
        action: '执行分配',
      },
      assignConfirm: {
        title: '确认分配宠物?',
        descLine1: '确定要为所有未分配宠物的孩子随机分配宠物吗？',
        descLine2: '已分配的孩子不会受到影响。',
        confirm: '确认分配',
      },
      assignSuccess: '分配成功',
      assignFailed: '分配失败',
      reset: {
        title: '重置所有孩子进度',
        subtitle: '将清空积分、宠物、徽章、成长记录与兑换记录，且不可撤销。',
        action: '重置所有孩子进度',
        cleared: '会被清空',
        kept: '会被保留',
        clearedItems: {
          points: '积分',
          petSelection: '宠物选择',
          petStage: '宠物阶段',
          badges: '徽章',
          coins: '金币',
          growthRecords: '成长记录',
          exchangeRecords: '兑换记录',
        },
        keptItems: {
          scoreRules: '加减分规则',
          levelRules: '等级规则',
          className: '家庭名称',
          groups: '分组',
          shopConfig: '小卖部配置',
        },
        warning: '本操作不可撤销，将清空成长记录与兑换记录。若需留档，请先导出 CSV 备份。',
        passwordLabel: '请输入登录密码',
        passwordPlaceholder: '请输入登录密码以确认',
        confirm: '确认重置',
        success: '重置成功',
        failed: '重置失败',
      },
    },
    import: {
      fromOtherClass: '从其他家庭导入',
      success: '导入成功',
      failed: '导入失败',
    },
    importModal: {
      title: '从其他家庭导入配置',
      descPrefix: '选择源家庭，其',
      descSuffix: '将',
      override: '覆盖',
      descEnd: '当前家庭的配置。',
      selectSourceClass: '选择来源家庭',
      selectClassPlaceholder: '请选择家庭...',
      confirm: '确认导入',
    },
    save: {
      success: '保存成功',
      failed: '保存失败',
    },
    update: {
      success: '更新成功',
      failed: '更新失败',
    },
    delete: {
      success: '删除成功',
      failed: '删除失败',
    },
    class: {
      createSuccess: '家庭创建成功',
      createFailed: '创建失败',
      deleteSuccess: '家庭已删除',
      deleteFailed: '删除失败，请稍后重试',
      deleteFailedHttp: '删除失败（HTTP {{status}}）',
      deleteNetworkError: '网络错误：{{message}}',
      deleteConfirm: {
        title: '确认删除家庭?',
        descPrefix: '您确定要删除 ',
        descSuffix: ' 吗？',
        descLine2: '该家庭将不再显示，需要输入登录密码确认。',
        passwordLabel: '登录密码',
        passwordPlaceholder: '请输入登录密码',
        passwordError: '密码错误，请重试',
        deleting: '删除中...',
        confirm: '确认删除',
      },
    },
    iconPicker: {
      title: '选择图标',
    },
    password: {
      title: '修改密码',
      confirm: '确认修改',
      success: '密码修改成功',
      error: {
        minLength: '新密码至少需要6个字符',
        mismatch: '两次输入的密码不一致',
        failed: '修改失败，请检查当前密码',
      },
      currentPassword: {
        label: '当前密码',
        placeholder: '请输入当前密码',
        hint: '请输入您当前使用的密码',
      },
      newPassword: {
        label: '新密码',
        placeholder: '请设置新密码',
        hint: '请设置新密码，至少6个字符',
      },
      confirmPassword: {
        label: '确认新密码',
        placeholder: '请再次输入新密码',
      },
    },
    groups: {
      title: '分组管理',
      subtitle: '共 {{count}} 个分组，最多 50 个',
      create: '新建分组',
      placeholder: '输入分组名称 (1-20字)',
      add: '添加',
      list: '分组列表',
      members: '小组成员',
      manageMembers: '管理小组成员',
      removeMember: '移出小组',
      random: {
        title: '随机分组',
        studentCount: '当前孩子数量 {{total}} 个，执行随机分组则把孩子随机分成',
        label: '组',
        action: '重新随机分组',
        confirmTitle: '确认随机分组',
        confirmDesc: '将清除现有分组并按 {{count}} 组重新分配，是否继续？',
        confirmAction: '继续',
      },
      addStudent: {
        title: '添加孩子到「{{groupName}}」',
        placeholder: '搜索孩子姓名',
        onlyUnassigned: '仅未分组',
        allowMultiple: '允许孩子同时属于多个分组',
        selected: '可选 {{total}} 人, 已选 {{selected}} 人',
        selectAll: '全选/反选',
        clear: '清空',
        confirm: '确认添加 {{count}} 人',
        collapse: '收起',
      },
      deleteConfirm: {
        title: '确认删除分组?',
        descPrefix: '您确定要删除 ',
        descSuffix: ' 吗？',
        desc: '删除后，组内学生将变为未分组状态。',
        confirm: '确认删除',
      },
      edit: '编辑分组',
    },
  },
  rank: {
    title: '光荣榜',
    selectClass: '选择家庭',
    boardTitle: '{{className}} 积分排行榜',
    topHint: 'Top 20',
    studentNumber: '编号',
    points: '积分',
    empty: '暂无排名数据',
  },
  petCenter: {
    title: '宠物中心',
    currentClass: '当前家庭',
    promptPetName: '给宠物起个名字吧：',
    exp: 'EXP',
    mood: '心情',
    hunger: '饱食度',
    guardianPet: '守护宠物',
    noPet: '还没有领养宠物哦',
    adoptNow: '立即领养',
    interactions: {
      title: '互动与照料',
      feed: {
        title: '喂食',
        desc: '消耗 10 积分，增加饱食度',
      },
      pet: {
        title: '抚摸',
        desc: '增加心情值 (待开发)',
      },
      play: {
        title: '玩耍',
        desc: '消耗体力，增加经验 (待开发)',
      },
    },
    log: {
      title: '成长日志',
      line1: '{{name}} 刚刚吃饱了，看起来很开心！',
      line2: '恭喜！{{name}} 升到了 Lv.{{level}}',
    },
  },
  classSelection: {
    title: {
      create: '创建新家庭',
      edit: '编辑家庭',
      manage: '家庭管理',
    },
    form: {
      className: '家庭名称',
      placeholder: '例如：我的家庭',
      confirmCreate: '确认创建',
      saveChanges: '保存修改',
    },
    footer: {
      createNew: '创建一个新家庭',
    },
  },
  leaderboard: {
    title: '光荣榜',
    subtitle: '养成宠物，荣登榜首',
    badges: '{{count}} 徽章',
    points: '{{count}} 积分',
    total: '总分',
    empty: '暂时还没有数据哦',
    rule: '* 排名规则：1个徽章 = {{badgePointValue}}分 + 当前积分',
    tabs: {
      individual: '个人榜',
      group: '小组榜',
    },
    average: '平均分',
    emptyGroup: '暂无小组数据',
  },
  petSelection: {
    title: '选择守护宠物',
    subtitle: '为 {{studentName}} 选择一只可爱的宠物吧',
    viewBaby: '查看幼崽形态',
    viewMax: '查看满级形态',
    unlocked: '已养成',
    hint: '点击选择宠物，宠物会陪伴你完成每日打卡任务',
  },
  pets: {
    unknown: '未知宠物',
    hamster: '仓鼠',
    hedgehog: '刺猬',
    unicorn: '独角兽',
    phoenix: '凤凰',
    dog: '小狗',
    dolphin: '海豚',
    fox: '狐狸',
    dinosaur: '恐龙',
    dragon: '小龙',
    cat: '小猫',
    owl: '猫头鹰',
    raccoon: '浣熊',
    rabbit: '兔子',
    deer: '小鹿',
    panda: '熊猫',
    tiger: '老虎',
    elephant: '大象',
    monkey: '猴子',
    penguin: '企鹅',
    gorilla: '大猩猩',
    butterfly: '蝴蝶',
    chicken: '小鸡',
    koala: '考拉',
    lion: '狮子',
    turtle: '乌龟',
    sheep: '小羊',
    bee: '蜜蜂',
    polar_bear: '北极熊',
    bat: '蝙蝠',
    chameleon: '变色龙',
    kangaroo: '袋鼠',
    crocodile: '鳄鱼',
    seahorse: '海马',
    walrus: '海象',
    hippo: '河马',
    flamingo: '火烈鸟',
    whale: '鲸鱼',
    peacock: '孔雀',
    frog: '青蛙',
    cow: '奶牛',
    shark: '鲨鱼',
    squirrel: '松鼠',
    rhino: '犀牛',
    pig: '小猪',
    duck: '鸭子',
    parrot: '鹦鹉',
    giraffe: '长颈鹿',
    treant: '树精',
    jellyfish: '水母',
    robot: '机器人',
    ultra: '高达',
  },
  renamePet: {
    title: '给宠物起名',
    subtitle: '{{studentName}} · {{petName}}',
    label: '宠物昵称',
    placeholder: '请输入昵称',
    hint: '仅支持 1-12 位中文/英文/数字',
    cancel: '取消',
    save: '保存',
  },
  resetPassword: {
    title: '找回密码',
    subtitle: '用激活码验证后，就能设置一个新密码',
    username: {
      label: '用户名',
      placeholder: '请输入用户名',
    },
    code: {
      label: '激活码',
      placeholder: '比如：ABCD-YYYY-ZZZZ',
      hint: '请输入您注册时使用的激活码',
    },
    newPassword: {
      label: '新密码',
      placeholder: '至少 6 个字符',
      hint: '请设置新密码，至少6个字符',
    },
    confirmPassword: {
      label: '确认新密码',
      placeholder: '请再次输入新密码',
    },
    processing: '处理中...',
    submit: '重置密码',
    success: '密码重置成功，请使用新密码登录',
    error: {
      minLength: '新密码至少需要6个字符',
      mismatch: '两次输入的密码不一致',
      failed: '重置失败，请检查用户名和激活码',
      foundUsername: '重置失败。该激活码对应的用户名是：{{username}}',
    },
  },
  growthRecords: {
    title: '成长记录',
    count: '{{shown}}/{{total}} 条记录',
    exportCsv: '导出CSV',
    exportFilename: '成长记录_{{dateStr}}.csv',
    exportFailed: '导出失败',
    undo: '撤销',
    undoFailed: '撤销失败',
    empty: '暂无记录',
    reverted: '（已撤销）',
    unknownStudent: '未知',
    csv: {
      time: '时间',
      student: '孩子',
      action: '操作',
      change: '变动',
    },
    confirmUndo: {
      title: '确认撤销',
      defaultStudent: '该孩子',
      add: '加分',
      deduct: '扣分',
      desc: '将撤销 {{name}} 的这条 {{action}} 记录，并生成一条撤销记录。',
      confirm: '确认撤销',
    },
    pagination: '第 {{current}}/{{totalPages}} 页 · 共 {{totalItems}} 条记录',
    tabs: {
      stats: '数据统计',
      history: '历史记录',
    },
    stats: {
      week: '本周',
      month: '本月',
      lastMonth: '上月',
      custom: '自定义',
      query: '查询',
      period: '{{start}} ~ {{end}}',
      totalGained: '总加分',
      totalLost: '总扣分',
      netChange: '净变动',
      totalActions: '操作次数',
      activeStudents: '活跃孩子',
      studentRanking: '孩子排名',
      rank: '排名',
      student: '孩子',
      gained: '加分',
      lost: '扣分',
      net: '净值',
      actions: '次数',
      dailyTrend: '每日趋势',
      noData: '该时段暂无数据',
      exportFilename: '数据统计_{{period}}_{{dateStr}}.csv',
    },
  },
  studentAction: {
    batchMode: '批量操作模式',
    batchTitle: '给 {{count}} 个孩子评分',
    pointsUnit: '积分',
    availablePointsUnit: '可用',
    petsCountUnit: '只宠物',
    currentExp: '当前经验',
    changePet: '更换宠物',
    tabs: {
      action: '评分',
      calendar: '日历',
      history: '记录',
      pets: '宠物',
    },
    calendar: {
      today: '今天',
      summary: '本月已打卡 {{count}} 次 · 共 {{points}} 分',
      empty: '本月暂无打卡记录',
    },
    searchPlaceholder: '搜索加分/扣分项目...',
    checkinItems: '打卡项目',
    noCheckinTasks: '还没有设置打卡任务',
    positiveItems: '加分项目',
    negativeItems: '扣分项目',
    behaviorItems: '行为习惯',
    behaviorFilterAll: '全部',
    behaviorFilterPositive: '加分',
    behaviorFilterNegative: '扣分',
    noItemsFound: '未找到相关项目',
    custom: {
      label: '自定义',
      titlePositive: '自定义加分',
      titleNegative: '自定义扣分',
      points: '分数',
      pointsPlaceholder: '输入分数',
      reason: '原因',
      optional: '(选填)',
      defaultPositive: '自定义加分',
      defaultNegative: '自定义扣分',
    },
    noHistory: '暂无评分记录',
    unknownAction: '未知操作',
    reverted: '（已撤销）',
    undo: '撤销',
    locked: '未解锁',
    undoFailed: '撤销失败',
    export: '导出记录',
    confirmUndo: {
      title: '确认撤销',
      add: '加分',
      deduct: '扣分',
      desc: '将撤销这条 {{action}} 记录，并生成一条撤销记录。',
      confirm: '确认撤销',
    },
    petStatus: {
      current: '当前状态',
      daysWithoutFeed: '连续未加分',
      daysCount: '{{count}} 天',
      nextState: '距离下一状态',
      toSleep: '距离沉睡',
      remainingDays: '{{count}} 天',
      awakenByPoints: '加分即可唤醒',
      sleepHint: '宠物等待新的鼓励来恢复活力。',
      none: '—',
    },
  },
  store: {
    title: '兑换商店',
    selectClass: '选择家庭',
    addGood: '上架商品',
    stock: '库存: {{count}}',
    exchangeToStudent: '兑换给孩子',
    soldOut: '已售罄',
    empty: '暂无商品，快去上架吧',
    alert: {
      selectClassFirst: '请先选择家庭',
      exchangeSuccess: '兑换成功！',
      exchangeFailed: '兑换失败',
    },
    addModal: {
      title: '上架新商品',
      name: '商品名称',
      price: '价格 (积分)',
      stock: '库存数量',
      confirm: '确认上架',
    },
    exchangeModal: {
      title: '兑换商品',
      desc: '正在兑换: {{name}} (消耗 {{price}} 积分)',
      selectClass: '选择家庭',
      chooseClass: '请选择家庭',
      selectStudent: '选择孩子',
      chooseStudent: '请选择兑换孩子',
      insufficient: '(积分不足)',
      studentOption: '{{name}} (积分: {{points}}) {{insufficient}}',
      confirm: '确认兑换',
    },
  },
  storeModal: {
    header: {
      storeTitle: '小卖部',
      manageTitle: '货架管理',
      tips: '每养成一个宠物系统会发放10个金币和1个徽章喔～',
    },
    tabs: {
      list: '商品列表',
      history: '记录',
      manageLong: '管理 商品',
      manageShort: '管理',
    },
    emptyList: '暂无商品上架',
    emptyListAction: '去添加商品',
    noDescription: '暂无描述',
    redeemNow: '立即兑换',
    soldOut: '已抢光',
    currentClass: '当前家庭：{{name}}',
    noClassSelected: '未选择家庭',
    importFromOther: '从其他家庭导入',
    stock: '库存',
    edit: '编辑',
    addNew: '添加新商品',
    noExchangeRecords: '暂无兑换记录',
    record: {
      defaultAvatar: '孩',
      unknownStudent: '未知孩子',
      redeemed: '兑换了',
      unknownGood: '未知商品',
    },
    exchangeSelect: {
      title: '选择兑换孩子',
      needCoins: '需要 {{price}} 可用积分',
      searchPlaceholder: '搜索孩子姓名...',
      currentCoins: '当前拥有 {{coins}} 可用积分',
      insufficientCoins: '可用积分不足',
      clickRedeem: '点击兑换',
      noStudentsFound: '未找到相关孩子',
    },
    confirmRedeem: {
      title: '确认兑换',
      desc: '确定要为 {{name}} 兑换 “{{goodName}}” 吗?',
      cost: '将消耗 {{price}} 可用积分',
    },
    confirmDelete: {
      title: '确认删除商品?',
      desc: '您确定要删除 “{{name}}” 吗？此操作无法撤销。',
      deleting: '删除中...',
      confirm: '确认删除',
    },
    editModal: {
      editTitle: '编辑商品',
      addTitle: '上架新商品',
      name: '商品名称',
      namePlaceholder: '例如：看电影券',
      description: '描述',
      descriptionPlaceholder: '例如：可以看一小时电视',
      price: '价格 (可用积分)',
      initialStock: '份数',
      iconType: '图标类型',
    },
    importModal: {
      title: '从其他家庭导入商品',
      subtitle: '同步小卖部商品设置到当前家庭',
      sourceClass: '源家庭',
      required: '必选',
      sourceClassPlaceholder: '请选择要导入的家庭（必选）',
      searchPlaceholder: '搜索商品名称...',
      selectAll: '全选',
      clear: '清空',
      selectedCount: '已选 {{selected}} / {{total}}',
      selectSourceClassFirst: '请选择源家庭',
      noImportableGoods: '暂无可导入商品',
      importing: '导入中...',
      startImport: '开始导入',
    },
    toast: {
      outOfStock: '库存不足',
      insufficientCoins: '可用积分不足',
      redeemSuccess: '兑换成功！{{name}} 已兑换「{{goodName}}」',
      redeemFailed: '兑换失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      enterName: '请输入商品名称',
      enterPrice: '请输入商品价格',
      enterStock: '请输入初始库存',
      selectClassFirst: '请先选择家庭',
      fetchClassesFailed: '获取家庭列表失败',
      fetchSourceGoodsFailed: '获取源家庭商品失败',
      selectSourceClass: '请选择源家庭',
      selectAtLeastOneGood: '请至少选择一个商品',
      importDone: '导入完成：新增{{created}}，更新{{updated}}，跳过{{skipped}}',
      importFailed: '导入失败',
    },
  },
  classManagement: {
    title: '家庭管理',
    create: {
      button: '新建家庭',
      title: '创建新家庭',
      placeholder: '请输入家庭名称',
      confirm: '确认创建',
    },
    edit: {
      title: '编辑家庭信息',
      placeholder: '家庭名称',
      save: '保存修改',
    },
    delete: {
      title: '删除家庭',
      willDelete: '即将删除：{{name}}',
      desc: '此操作会让该家庭在你的系统中不可见，且需要输入登录密码确认。',
      passwordLabel: '请输入登录密码',
      passwordPlaceholder: '登录密码',
      confirm: '确认删除',
      errorFallback: '删除失败，请稍后重试',
    },
    sidebar: {
      title: '我的家庭',
      empty: '暂无家庭，请先创建',
    },
    studentsTotal: '孩子总数: {{count}} 人',
    addStudent: {
      button: '添加孩子',
      name: '姓名',
      studentNumber: '学号 (选填)',
    },
    table: {
      name: '姓名',
      studentNumber: '学号',
      points: '当前积分',
      actions: '操作',
      edit: '编辑',
      empty: '暂无孩子数据',
    },
    noClassSelected: '请选择左侧家庭查看详情',
  },
  login: {
    appName: '宝贝习惯园',
    tagline1: '每天进步一点点，宠物就会长大一点点',
    tagline2: '完成任务拿积分，解锁新伙伴',
    tabs: {
      login: '登录',
      register: '注册',
    },
    username: {
      label: '用户名',
      placeholder: '请输入用户名',
    },
    password: {
      label: '密码',
      placeholder: '请输入密码',
      show: '显示密码',
      hide: '隐藏密码',
    },
    activationCode: {
      label: '激活码',
      placeholder: '请输入系统激活码',
      hint: '激活码由系统管理员分发，用于验证身份',
    },
    renewCode: {
      label: '新的激活码（用于续期）',
      placeholder: '请输入新的激活码',
      hint: '续期成功后会自动登录',
    },
    processing: '处理中...',
    submit: {
      login: '立即登录',
      register: '立即注册',
      renewAndLogin: '续期并登录',
    },
    forgotPassword: '忘记密码？用激活码找回 ➜',
    switch: {
      noAccount: '还没有帐号？',
      hasAccount: '已有帐号？',
      toRegister: '去注册',
      toLogin: '去登录',
    },
    errors: {
      expired: '账号已过期，请输入新的激活码续期后登录',
      failed: '登录失败，请再试一次',
    },
    rememberMe: '记住用户名',
  },
  home: {
    selectClass: '选择家庭',
    searchPlaceholder: '搜索孩子...',
    nav: {
      store: '小卖部',
      leaderboard: '光荣榜',
      reports: '报告',
      settings: '设置',
      tools: '工具',
    },
    tools: {
      title: '常用工具',
      random: {
        title: '随机抽奖',
        action: '开始抽奖',
        rolling: '抽取中...',
        reset: '重置',
        result: '抽到了：{{name}}',
        count: '抽取人数',
        review: '评价',
        excludePicked: '不重复抽取',
        remaining: '剩余 {{count}} 人',
        resetPicked: '重置',
      },
      timer: {
        title: '倒计时/计时',
        countdown: '倒计时',
        stopwatch: '正向计时',
        start: '开始',
        pause: '暂停',
        reset: '重置',
        minutes: '分钟',
        seconds: '秒',
        timeUp: '时间到！',
        custom: '自定义',
        set: '设置',
        placeholder: '输入分钟数(如0.5)或MM:SS(如0:30)',
      },
      noise: {
        title: '噪音检测',
        sensitivity: '灵敏度',
        level: '当前噪音',
        hint: '请允许使用麦克风以检测噪音',
      },
    },
    sort: {
      title: '排序方式',
      score: '按分数',
      name: '按名字',
    },
    viewMode: {
      compact: '小图模式',
      normal: '普通模式',
    },
    lock: {
      button: '锁屏',
      locked: '锁定',
      unlockButton: '解锁',
      setTitle: '设置密码',
      confirmTitle: '确认密码',
      unlockTitle: '输入密码解锁',
      setHint: '请输入4位数字密码',
      confirmHint: '请再次输入4位数字密码',
      unlockHint: '请输入锁屏密码',
      cancel: '取消',
      wrong: '密码错误，请重试',
      mismatch: '两次输入不一致，请重新设置',
      saveSuccess: '锁屏密码设置成功',
      saveFailed: '锁屏密码保存失败',
      changePassword: '修改密码',
      verifyTitle: '验证原密码',
      verifyHint: '请输入当前锁屏密码',
      changeSuccess: '锁屏密码修改成功',
    },
    batch: {
      enter: '批量',
      exit: '退出',
      hint: '点击卡片选择孩子，然后批量喂养',
      selectedPrefix: '已选择',
      selectedSuffix: '人',
      selectAll: '全选',
      deselectAll: '取消全选',
      clear: '清空',
      feed: '批量喂养',
    },
    empty: {
      noClasses: {
        title: '还没有创建家庭',
        desc: '创建一个家庭开始你的成长之旅吧！你可以添加孩子、管理积分和宠物。',
        action: '立即创建家庭',
      },
      noStudents: {
        title: '还没有添加孩子',
        desc: '快去添加孩子，开始宝贝习惯养成之旅吧！',
        action: '添加孩子',
      },
    },
    student: {
      adopt: '点击领养',
      mysteryEgg: '神秘蛋',
      progress: '本级进度',
      hatching: '等待孵化',
      maxLevel: '已满级',
      remaining: '还差 {{count}}',
      changePet: '更换',
      daysWithoutFeed: '未加分',
      daysCount: '{{count}} 天',
      nextStateIn: '距离下一状态还有 {{count}} 天',
      sleepIn: '距离沉睡还有 {{count}} 天',
      sleepHint: '宠物已经沉睡，给它加分就能唤醒',
      waitingWakeUp: '等待新的鼓励来恢复活力',
    },
    summon: '召唤守护宠物',
    feedback: {
      batchSuccess: '批量操作成功',
      addSuccess: '加分成功',
      deductSuccess: '扣分成功',
      appliedTo: '已应用到 {{count}} 个孩子',
    },
    levelUp: {
      maxTitle: '满级啦！',
      levelUpTitle: '升级啦！',
      promote10: '晋升 10 级',
      maxAchieved: '⭐ 满级达成 ⭐',
      promoteN: '晋升 {{level}} 级',
      maxForm: '已达最强形态',
      stronger: '变得更强了',
      footer: '{{name}} 的宠物{{status}}',
    },
    prestige: {
      title: '养成成功！',
      congrats: '恭喜 {{name}}',
      petBadge: '⭐ 守护宠物 · 满级形态 ⭐',
      badgeReward: '获得养成徽章 +1',
      coinsReward: '获得金币 +10',
      note: '✨ 徽章将永久保存在你的收藏中 ✨',
      later: '稍后再说',
      collect: '收集徽章',
    },
  },
  parentShare: {
    title: '家庭查看',
    titleWithClass: '{{className}} · 查看',
    loading: '正在加载...',
    invalidLink: '链接无效或已过期',
    disabledMessage: '已关闭查看功能',
    points: '积分：{{points}}',
    nameLabel: '孩子姓名',
    namePlaceholder: '请输入孩子姓名',
    nameHint: '请与设置的孩子姓名完全一致（含编号/符号）。',
    submit: '查看',
    searching: '查询中...',
    lookupFailed: '查询失败，请稍后重试',
    currentExp: '当前经验',
    tabs: {
      history: '记录',
      pets: '宠物',
    },
    emptyHistory: '暂无记录',
    revertedSuffix: ' · 已撤销',
    catalogTitle: '宠物图鉴',
    ownedCount: '已养成：{{count}}',
    owned: '已养成',
    locked: '未解锁',
    noPet: '暂无宠物',
    footerNote: '本页面仅用于查看宠物信息',
  },
  checkin: {
    title: '每日打卡',
    todayProgress: '今日进度 {{done}}/{{total}}',
    complete: '完成',
    completed: '已完成',
    undo: '取消打卡',
    taskManagement: '打卡任务管理',
    taskManagementSubtitle: '设置每日打卡任务 ({{count}}个)',
    addTask: '添加任务',
    weekdayShort: {
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六',
      sun: '日',
    },
    form: {
      addTitle: '新建打卡任务',
      editTitle: '编辑打卡任务',
      name: '任务名称',
      points: '奖励积分',
      dateRange: '起止日期',
      dateHint: '留空表示不限制开始或结束日期',
      dateNoLimit: '长期有效',
      dateRangeInvalid: '开始日期不能晚于结束日期',
      clearDates: '清除',
      repeat: '重复日期',
      repeatRequired: '至少选择一天',
      preset: {
        all: '全选',
        weekdays: '工作日',
        weekend: '周末',
      },
    },
    taskName: '任务名称',
    taskNamePlaceholder: '例如：刷牙、阅读30分钟',
    taskPoints: '奖励积分',
    noTasks: '还没有设置打卡任务，去设置中添加吧',
    noChildren: '请先添加孩子',
    history: '打卡记录',
    deleteTitle: '删除打卡任务',
    deleteConfirm: '确定要删除任务「{{name}}」吗？',
    toast: {
      completeSuccess: '打卡成功！',
      completeFailed: '打卡失败',
      uncompleteSuccess: '已取消打卡',
      uncompleteFailed: '取消打卡失败',
      taskCreated: '任务创建成功',
      taskCreateFailed: '任务创建失败',
      taskDeleted: '任务已删除',
      taskDeleteFailed: '删除任务失败',
    },
  },
  onboarding: {
    title: '欢迎来到宝贝习惯园',
    subtitle: '先添加一个孩子开始养成之旅吧',
    nameLabel: '宝贝昵称',
    namePlaceholder: '例如：糖糖',
    ageRangeLabel: '宝贝年龄段',
    ageRangeHint: '我们会按年龄段自动导入合适的打卡任务、行为习惯和小卖部商品',
    'ageRange_3-5': '3-5 岁',
    'ageRange_6-9': '6-9 岁',
    ageRange_10plus: '10+ 岁',
    create: '创建宝贝',
    creating: '创建中...',
    errors: {
      nameRequired: '请输入宝贝昵称',
      createFailed: '创建失败，请稍后重试',
    },
  },
  reports: {
    title: '家庭周报',
    empty: '本期没有数据',
    exportImage: '导出图片',
    preset: {
      thisWeek: '本周',
      lastWeek: '上周',
      thisMonth: '本月',
      lastMonth: '上月',
    },
    card: {
      totalPoints: '总积分',
      availablePoints: '可用',
      gained: '加分',
      lost: '扣分',
      net: '净增',
      gainedShort: '加',
      lostShort: '扣',
      topBonus: 'TOP 加分',
      topDeduction: 'TOP 扣分',
      checkinRate: '打卡完成率',
      redemptions: '兑换记录',
      noRedemptions: '本期无兑换',
    },
    toast: {
      fetchFailed: '获取报告失败',
    },
  },
};

export default zhCN;
